export interface UxBuildInfo {
  sha: string;
  shortSha: string;
  branch: string;
  builtAt: string;
  mode: string;
  appVersion: string;
  pipelineBuildId?: string;
  pipelineBuildNumber?: string;
}

const FETCH_TIMEOUT_MS = 3000;

/**
 * Fetches the SWA-served /version.json (written by the buildInfoPlugin in vite.config.ts).
 * Returns null when the file is absent (e.g. local dev server) or fetch fails — callers
 * should fall back to compile-time __APP_VERSION__.
 */
export const fetchUxBuildInfo = async (): Promise<UxBuildInfo | null> => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);

  try {
    const response = await fetch("/version.json", {
      method: "GET",
      cache: "no-store",
      headers: { Accept: "application/json" },
      signal: controller.signal,
    });
    if (!response.ok) return null;
    return (await response.json()) as UxBuildInfo;
  } catch {
    return null;
  } finally {
    clearTimeout(timeoutId);
  }
};
